<script lang="ts">
    import robot from '../assets/robot.avif';
    import bubble from '../assets/speechbubble.avif';
    import think from '../assets/thinkingbubble.avif';
    import play from '../assets/play.svg';
    import retry from '../assets/retry.svg';
    import Thinking from './Thinking.svelte';
    import { Form, FormGroup, Input } from 'sveltestrap';
    import { createStory } from './createStory';
    import { useNavigate } from 'svelte-navigator';

    enum FormState {
        IDLE,
        LOADING,
        SUCCESS,
        ERROR,
    }
    let state: FormState = FormState.IDLE;

    let title: string = '';
    let presentationId: string | undefined = undefined;

    function onSubmit(event: SubmitEvent) {
        event.preventDefault();

        state = FormState.LOADING;

        createStory(title).then(
            (id) => {
                presentationId = id;
                state = FormState.SUCCESS;
            },
            () => {
                state = FormState.ERROR;
            }
        );
    }

    const navigate = useNavigate();

    function playStory() {
        if (presentationId) {
            navigate(`/story/read/${presentationId}`);
        } else {
            state = FormState.ERROR;
        }
    }

    function doRetry() {
        presentationId = undefined;
        state = FormState.IDLE;
    }
</script>

<div class="wrapper">
    <div class="robot-wrapper">
        <img src={robot} alt="" class="waiting-robot" />
        {#if state === FormState.SUCCESS}
            <button class="action-button play-button" on:click={playStory}>
                <img src={play} alt="vorlesen" />
            </button>
        {:else if state === FormState.ERROR}
            <button class="action-button retry-button" on:click={doRetry}>
                <img src={retry} alt="nochmal probieren" />
            </button>
        {/if}
        {#if state === FormState.IDLE || state === FormState.SUCCESS || state === FormState.ERROR}
            <img src={bubble} alt="" class="speech-bubble" />
            <h2 class="robot-speech">
                {#if state === FormState.IDLE}
                    Worüber soll ich dir eine Geschichte erzählen?
                {:else if state === FormState.SUCCESS}
                    Fertig! Soll ich dir die Geschichte vorlesen?
                {:else if state === FormState.ERROR}
                    Ups, da ist etwas schief gelaufen.
                {/if}
            </h2>
        {:else if state === FormState.LOADING}
            <img src={think} alt="" class="think-bubble" />
            <span class="thought"
                ><Thinking length={7} /><br /><Thinking length={6} /></span
            >
        {/if}
    </div>
    <div class="input-wrapper">
        <Form on:submit={onSubmit}>
            <FormGroup floating label="Dein Titel">
                <Input
                    bind:value={title}
                    type="text"
                    name="topic"
                    id="topic"
                    bsSize="lg"
                    autofocus
                    maxlength={150}
                    required
                    readonly={state !== FormState.IDLE}
                />
            </FormGroup>
            <Input
                type="submit"
                value="los geht's"
                disabled={!title || state !== FormState.IDLE}
                bsSize="lg"
                color="primary"
                class={state !== FormState.IDLE ? 'invisible' : ''}
            />
        </Form>
    </div>
</div>

<style>
    .input-wrapper {
        margin-bottom: 60svh;
        width: 60svw;
    }

    .robot-wrapper {
        position: absolute;
        bottom: 0;
        left: 0;
        scale: 1.2;
    }

    .waiting-robot {
        position: absolute;
        bottom: 0;
        left: 10svh;
        transform: scaleX(-1);
        height: 30svh;
    }

    .speech-bubble {
        position: absolute;
        bottom: 27svh;
        left: 0;
        height: 20svh;
    }

    .think-bubble {
        position: absolute;
        bottom: 25svh;
        left: 12svh;
        height: 26svh;
    }

    .thought {
        position: absolute;
        bottom: 35.5svh;
        left: 16svh;
        font-size: 3.5svh;
        transform: rotate(10deg);
        font-family: monospace;
        letter-spacing: 0.6svh;
    }

    .robot-speech {
        font-size: 3svh;
        position: absolute;
        bottom: 35.5svh;
        left: 5svh;
        text-align: center;
        transform: rotate(-3deg);
        width: 40svh;
    }

    .wrapper {
        position: relative;
        width: 90svw;
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .invisible {
        opacity: 0;
    }

    .action-button {
        all: unset;
        cursor: pointer;
        height: 8svh;
        width: 8svh;
        border-radius: 50%;
        position: absolute;
        bottom: 8svh;
        left: 21.5svh;
        padding: 0.5svh;
        box-sizing: border-box;
        filter: drop-shadow(0 0 0.75rem rgba(255, 255, 255, 0.5));
    }

    .play-button {
        background-color: limegreen;
    }

    .play-button:hover {
        background-color: darkgreen;
    }

    .retry-button {
        background-color: crimson;
        padding: 1.5svh;
    }

    .retry-button:hover {
        background-color: darkred;
    }
</style>
